import { log } from './log';

export function icons() {
  const fn = window.loadIcons || null;

  if (typeof fn === 'function') {
    try {
      fn('/assets/img/spectrum-css-icons.svg');
      fn('/assets/img/spectrum-icons.svg');
      log('Loaded spectrum icons');
    } catch (err) {
      log('Failed to load spectrum icons');
    }
  }
}
